export const accessToken = document.querySelector('meta[name="csrf-token"]')?.content
